import { constants } from '@clubmed/utils';
import { t } from 'Src/i18n';
const { FLEX_RATES } = constants;
export const getRateMessagesProperties = (rate: string) => {
  switch (rate) {
    case FLEX_RATES.NRR:
      return {
        rateTitle: t('booking.accommodation.packageContent.nonRefundableRateLabel'),
        rateContent: t('booking.accommodation.packageContent.nonRefundableRateLegal'),
      };

    case FLEX_RATES.FLR:
      return {
        rateTitle: t('booking.accommodation.packageContent.flexibleRateLabel'),
        rateContent: t('booking.accommodation.packageContent.flexibleRateLegal'),
      };

    default:
      return {
        rateTitle: t('booking.accommodation.packageContent.standardLabel'),
        rateContent: t('booking.accommodation.packageContent.standardLegal'),
      };
  }
};
